<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="point-terms-of-service">
      <Title jpn="硬币使用条款" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">本使用条款（以下简称“Coin 使用条款”）规定了在
              <a href="https://gtchaxonline.com/" target="_blank" >https://gtchaxonline.com/ </a>
              上使用 Xero Place Co., Ltd.（以下简称“公司”）提供的“Coin”（定义如下）（以下简称“服务”）的条件。
            </span>
            <span class="text">在考虑购买 Coin 之前，请仔细阅读 Coin 使用条款。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第 1 条 - 术语定义</span>
            <span class="text">本条款中下列各项中术语的含义应按各项规定。</span>
            <span class="text">(1) “服务使用协议”是指有关服务使用的合同。</span>
            <span class="text">(2) “服务使用者”是指与本公司签订服务使用合同的人。</span>
            <span class="text">(3) “账户信息”是指服务使用者在本服务中注册的与服务使用者相关的信息。</span>
            <span class="text">(4) “货币”是指只能由本公司使用的货币。</span>
            <span class="text">(5) “已用余额”是指服务使用者持有并可供使用的代币余额。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第 2 条 - 硬币</span>
            <span class="text">(1) 服务使用者可以按照公司指定的方法以及公司在服务中指定的价格购买可在服务中使用的硬币。此外，公司可以为服务使用者设定购买金币的购买单位、支付方式、使用期限以及其他购买条件，设定的购买条件和支付金额等将在本服务或公司运营的服务中公示。</span>
            <span class="text">(2) 当服务利用者按照公司规定的方式表达购买硬币的意向时，服务利用者与公司之间应签订有关购买硬币的合同，并确定购买总额。</span>
            <span class="text">(3) 如果购买Coin的服务使用者是未成年人，服务使用者在购买Coin之前必须获得父母或监护人的同意。</span>
            <span class="text">(4) 如果未成年人购买代币，公司将假定拥有父母权力的人已同意购买代币。</span>
            <span class="text">(5) 本服务中显示的服务使用者的使用余额将与帐户信息关联，并记录在用于提供本服务和本公司运营的其他服务的电信设备中。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第 3 条 - 硬币的使用</span>
            <span class="text">(1)金币可以用来购买我们的产品。</span>
            <span class="text">(2) 服务使用者可以在其Coin余额范围内购买公司提供的产品。</span>
            <span class="text">(3) 如果服务使用者使用Coin向公司购买商品，则该商品的价格将从Coin余额中扣除，该金额将被视为已支付。</span>
            <span class="text">除非另有说明，本公司在服务范围内向服务使用者免费发放的金币将优先使用。</span>
            <span class="text">(4) 服务用户可以在服务内查看其Coin余额。另外，服务使用者有责任管理和检查币的增减。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第 4 条 - 硬币的处理</span>
            <span class="text">(1) 当用户在本服务中购买金币、公司开展活动或其他情况下，公司将按照公司确定的方法向用户授予金币。硬币购买单位、价格、有效期和其他授予硬币的条件将由公司确定并显示在服务上。</span>
            <span class="text">(2) 硬币的有效期为自授予之日起6个月。</span>
            <span class="text">(3) 除非法律要求，公司不会退还用户获得的任何硬币。根据法律法规要求退还硬币时，退还方法和条件将按照公司确定的方式另行公布。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第 5 条 - 禁止现金兑换等</span>
            <span class="text">对于在本服务中获得的所有内容，禁止以给予或接受金钱或其他现实世界报酬（包括但不限于所谓的 RMT [真实货币交易]）的形式进行任何转让、转移、出借、借用等，无论是直接、通过第三方中介、互联网拍卖或其他方式。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第 6 条 - 硬币等的转让</span>
            <span class="text">服务用户不得向第三方转让、出借、赠送或以其他方式转让代币或产品，也不得质押或以其他方式设定担保权益。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第7条 - 停止购买和使用硬币等</span>
            <span class="text">如果服务使用者有下列情形之一，公司可以对该服务使用者采取公司认为适当的措施（包括但不限于暂停购买或使用Coin）。</span>
            <span class="text">(1) 如果通过非法手段获取或使用货币或产品</span>
            <span class="text">(2) 如果服务使用者违反本使用条款</span>
            <span class="text">(3) 本公司认为服务利用者使用本服务不适当的其他情况。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">成立于2025年2月28日</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n_point_terms_of_service';

export default {
  name: 'TermsOfService',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.point-terms-of-service{
  width: 100%;
  max-width: 1000px;
  min-height: 100%;
  padding: 30px 20px 0px;
  margin: 0px auto;
  .point-terms-of-service-title{
    display: flex;
    justify-content: center;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0px 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          a {
            color: black!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
</style>
